import { getBlogList } from '@/request/common';
import { Post } from '@/request/interface/common';
import { getRandomItems } from '@/utils/array';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useBlogList = ({
  storeName,
  cat_id,
  randomLength = 3,
}: {
  storeName: string;
  cat_id?: string;
  randomLength?: number;
}) => {
  const { i18n } = useTranslation(['common']);
  const [blogList, setBlogList] = useState<Post[]>([]);
  const [isStore, setIsStore] = useState(false);

  useEffect(() => {
    const blogs = JSON.parse(localStorage.getItem(storeName) || '{}');
    if (dayjs().format('YYYY-MM-DD') === blogs?.date) {
      setIsStore(true);
      setBlogList(blogs?.data || []);
      return;
    }
    getBlogList({ lang: i18n.language || 'en', cat_id, number: randomLength }).then((res) => {
      const posts = res?.[0]?.posts || [];
      let randomPosts = posts;
      if (posts?.length >= randomLength) {
        randomPosts = getRandomItems(posts, randomLength);
      } else {
        randomPosts = getRandomItems(posts, posts?.length);
      }
      setBlogList(randomPosts);
      localStorage.setItem(storeName, JSON.stringify({ data: randomPosts, date: dayjs().format('YYYY-MM-DD') }));
    });
  }, [i18n.language, cat_id]);

  return {
    isStore,
    blogList,
  };
};

export default useBlogList;
